import React, {useEffect, useState} from "react";
import "./ImageSliderContainer.sass";
import _ from "lodash";

export const ImageSliderContainer = ({images}) => {

    const [width, setWidth] = useState(0)

    const [content, setContent] = useState([]);
    const [position, setPosition] = useState(0);
    const [intervalId, setIntervalId] = useState(-1);

    useEffect(() => {
        updateWidth()
        if (_.isEmpty(images)) {
            const empty = <div>нет картинок</div>
            setContent([empty])
        } else {
            setContent(images)
            createInterval()
        }

        return () => removeInterval()
    }, [])

    const updateWidth = () => {
        const root = document.getElementById("ImageSliderContainer-root")
        if (root) {
            setWidth(root.offsetWidth)
        }
    }

    const createInterval = () => {
        const interval = setInterval(() => {
            updateWidth();
            setPosition(prevPosition => prevPosition === (images.length - 1)
                ? 0
                : prevPosition + 1);
        }, 5000)
        setIntervalId(interval)
    }

    const removeInterval = () => {
        clearInterval(intervalId);
        setIntervalId(-1);
    }

    const renderImages = () => {
        const style = {
            maxWidth: width,
            minWidth: width,
            width: width,
        }
        return <div className="ImageSliderContainer-content-img"
                    style={style}>
            <img src={content[position]} alt={`Преимущество платформы`}/>
        </div>
    }

    const renderPoints = (item, i) => {
        let style = {}
        if (position === i) {
            style = {
                width: '1.5em',
                height: '1.5em'
            }
        }
        return <div key={`point-${i}`}
                    style={style}
                    onClick={() => setPosition(i)}
                    className="ImageSliderContainer-point">

        </div>
    }

    return (
        <div id="ImageSliderContainer-root"
             onMouseEnter={() => removeInterval()}
             onMouseLeave={() => createInterval()}
             style={{height: `calc(${width / 16 * 9}px + 3.5em`}}
             className="ImageSliderContainer-wrapper">
            <div className="ImageSliderContainer-content">
                {renderImages()}
            </div>
            <div className="ImageSliderContainer-points">
                {content.map(renderPoints)}
            </div>
        </div>
    )
}